import { PORTFOLIO_REAL_PATH } from 'config/api.routes';
import services from 'service/axios';
import { handleResponse } from 'utils/responseTransformer';
import type { GenericResponse } from 'commons/modules/generic-response';
import type { LastDateResponse } from 'commons/modules/service/last-dates';

export const lastDatesOfOperationService = async (
  investmentAccounts = '',
): Promise<GenericResponse<LastDateResponse>> => {
  try {
    const query = `investmentAccount=${investmentAccounts}`;

    const res = await services.wt_api(
      `${PORTFOLIO_REAL_PATH}/last-operation-date?${query}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );
    const { data, status } = res;
    return handleResponse(data, status, true);
  } catch (error: any) {
    return handleResponse(
      null,
      error?.response?.status,
      false,
      error,
      null,
      error?.response?.data.message,
    );
  }
};

export const lastLoadLayoutDateService = async (): Promise<
  GenericResponse<LastDateResponse>
> => {
  try {
    const res = await services.wt_api(
      `${PORTFOLIO_REAL_PATH}/last-operation-date-query`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );
    const { data, status } = res;
    return handleResponse(data, status, true);
  } catch (error: any) {
    return handleResponse(
      null,
      error?.response?.status,
      false,
      error,
      null,
      error?.response?.data.message,
    );
  }
};
